AFRAME.registerComponent('tradingview-universal-chart', {
    schema: {
        intervals: { type: 'number', default: 200 },
        multiplier: { type: 'string', default: '14' },
        timespan: { type: 'string', default: 'day' },
        startDate: { type: 'string', default: '' },
        endDate: { type: 'string', default: '' },
        stockData: { type: 'string', default: '' },
        dataInterval: { type: 'string', default: '1d' },
        candlestickSpacing: { type: 'number', default: 0.01 },
        width: { type: 'number', default: 200 },
        height: { type: 'number', default: 320 },
        scale: { type: 'string', default: '11 11 11' },
        position: { type: 'string', default: '0 0 -0.48' },
        type: { type: 'string', default: 'mountain', oneOf: ['mountain', 'candlestick', 'line'] },
        volumeHeight: { type: 'number', default: 0.3 },
        paneGap: { type: 'number', default: 0.2 },
        showEvents: { type: 'boolean', default: false },
        isETTimeZone: { type: 'boolean', default: true },
        secondarySeriesType: { type: 'string', default: 'volume', oneOf: ['volume', 'dividend', 'sip'] },
    },

    init: async function () {
        console.log('[TradingView Universal] Initializing v2 component');

        this.applyDataFromStorage();

        this.dataIntervalListener = (event) => {
            const { interval } = event.detail;
            console.log(`[TradingView Universal] Received data-interval: ${interval}`);
            this.el.setAttribute('tradingview-universal-chart', 'dataInterval', interval.toLowerCase());
        };
        this.el.sceneEl.addEventListener('data-interval', this.dataIntervalListener);

        this.boundOnSearchModeChanged = this.onSearchModeChanged.bind(this);
        this.el.sceneEl.addEventListener('search-mode-state', this.boundOnSearchModeChanged);

        const container = document.querySelector('#right-live-chart');
        if (container) container.classList.add('show');

        const noSelectedStockPopup = document.querySelector('#no-selected-stock-message');
        if (noSelectedStockPopup) noSelectedStockPopup.classList.remove('show');
        
        this.setupSizeListener();

        this.updateChartZoom();
        this.boundUpdateChartZoom = this.updateChartZoom.bind(this);
        window.addEventListener('resize', this.boundUpdateChartZoom);

        if (typeof window.TradingViewCore === 'undefined') {
            console.error('[TradingView Universal] TradingViewCore not found. Make sure TradingViewCore.js is included.');
            return;
        }
        this.core = new window.TradingViewCore(this.el, container, this.data);
        await this.core.init();
    },

    applyDataFromStorage: function () {
        if (typeof getCacheItem === 'function') {
            try {
                const popupSettings = getCacheItem('rightConfigurePopupSettings');
                if (popupSettings) {
                    if (this.data.type !== popupSettings.chartType && typeof popupSettings.chartType === 'string') {
                        this.data.type = popupSettings.chartType.toLowerCase();
                    }
                    if (this.data.showEvents !== popupSettings.showEvents && typeof popupSettings.showEvents === 'boolean') {
                        this.data.showEvents = popupSettings.showEvents;
                    }
                }
            } catch (e) {
                console.warn('[TradingView Universal] Failed to read from popup settings');
            }
        }
    },

    update: async function (oldData) {
        if (!this.core) return;
        const changedKeys = Object.keys(this.data).filter(k => this.data[k] !== oldData[k]);
        if (changedKeys.includes('stockData')) {
            const noSelected = document.querySelector('#no-selected-stock-message');
            const htmlC = document.querySelector('#right-live-chart');
            if (htmlC) htmlC.classList.add('show');
            if (noSelected) noSelected.classList.remove('show');
        }
        this.core.config = this.data; // Ensure core has the latest config reference
        await this.core.update(oldData);
    },

    updateChartZoom: function () {
        const isOverlay = document.getElementById('center-chart-overlay');
        const rightWrapper = document.querySelector('.right-wrapper');
        const isFullscreen = rightWrapper && rightWrapper.classList.contains('financials-expanded');

        if (isOverlay || isFullscreen) {
            const chartElem = document.querySelector('.chart-container');
            if (chartElem) chartElem.style.zoom = '1';
            return;
        }

        const container = document.querySelector('#right-container');
        if (!container) return
        const containerWidth = container.getBoundingClientRect().width - 28
        const aspectPerChart = containerWidth / this.data.width
        const chartElem = document.querySelector('.chart-container')
        if (chartElem && aspectPerChart) {
            chartElem.style.zoom = (aspectPerChart).toString()
        }
    },
    
    setupSizeListener: function () {
        const rightWrapper = document.querySelector('.right-wrapper');
        if (!rightWrapper) return

        this._panelSizeObserver = new MutationObserver((mutations) => {
            for (const m of mutations) {
                if (m.attributeName === 'class') {
                    const isFullScreen = rightWrapper.classList.contains('financials-expanded') 
                    this.updateSize(isFullScreen);
                }
            }
        });
        this._panelSizeObserver.observe(rightWrapper, { attributes: true });
    },

    onSearchModeChanged: function (event) {
        this.updateSize(event.detail);
    },
    
    updateSize: function (isFullScreen) {
        const applySize = () => {
            const chart = this.core?.chart;
            if (!chart) {
                return;
            }

            if (isFullScreen &&
                document.documentElement.classList.contains('desktop4-right-chart-fullscreen') &&
                window.StockStormDesktop4Scale?.resizeRightPanelChart) {
                window.StockStormDesktop4Scale.resizeRightPanelChart();
                return;
            }

            let newWidth = (this.core.config?.width || 400) - 8;
            let newHeight = (this.core.config?.height || 320) - 125;

            if (isFullScreen) {
                const chartContainer = document.querySelector('.live-chart-tab .chart-container');
                const chartContent = chartContainer?.querySelector('.chart-content');
                const headerHeight = chartContainer?.querySelector('.chart-header')?.offsetHeight || 115;
                const boundsWidth = chartContainer?.offsetWidth || newWidth + 8;
                const boundsHeight = chartContainer?.offsetHeight || newHeight + headerHeight + 16;
                newWidth = Math.max(240, boundsWidth - 8);
                newHeight = Math.max(180, boundsHeight - headerHeight - 16);
                if (chartContent) {
                    chartContent.style.height = `${newHeight}px`;
                }
            } else {
                newWidth = 400;
            }

            chart.resize(newWidth, newHeight);
            if (this.core.config) {
                this.core.config.width = newWidth + 8;
                this.core.config.height = newHeight + 125;
            }
            this.updateChartZoom();
        };

        if (isFullScreen) {
            requestAnimationFrame(() => {
                requestAnimationFrame(applySize);
            });
            [120, 400, 700].forEach((delay) => window.setTimeout(applySize, delay));
            return;
        }

        window.setTimeout(applySize, 600);
    },

    remove: function () {
        console.log('[TradingView Universal] Component being removed');
        if (this.dataIntervalListener) {
            this.el.sceneEl.removeEventListener('data-interval', this.dataIntervalListener);
            this.dataIntervalListener = null;
        }
        if (this.boundUpdateChartZoom) {
            window.removeEventListener('resize', this.boundUpdateChartZoom);
            this.boundUpdateChartZoom = null;
        }
        if (this.boundOnSearchModeChanged) {
            this.el.sceneEl.removeEventListener('search-mode-state', this.boundOnSearchModeChanged);
            this.boundOnSearchModeChanged = null;
        }
        if (this._panelSizeObserver) this._panelSizeObserver.disconnect();
        if (this.core) {
            this.core.remove();
            this.core = null;
        }
    }
});
